import { useEffect, useRef, useState } from 'react';
import { SelectOption } from '../../../types';
import { GroupInfo, UsersShared, type textState } from './Steps';
import StepProgress from '../../../juristec-ui/core/StepProgress';

interface SubmitData {
  name: string;
  description: string;
}

interface GroupManagerProps {
  users: SelectOption[];
  shared?: SelectOption[];
  groupData?: {
    name: string;
    description: string;
  };
  submit: (data: SubmitData, users: string[]) => void;
  hide: () => void;
  usersOnly?: boolean;
}

const GroupManager = ({
  users,
  shared,
  groupData,
  submit,
  hide,
  usersOnly = false,
}: GroupManagerProps) => {
  const isDirty = useRef<boolean>(false);
  const [name, setName] = useState<textState>({
    value: '', error: true, errorMsg: '',
  });
  const [description, setDescription] = useState<textState>({
    value: '', error: false, errorMsg: '',
  });
  const [tempShared, setTempShared] = useState<SelectOption[]>(shared ?? []);

  useEffect(() => {
    if (groupData) {
      setName({ value: groupData.name, error: false, errorMsg: '' });
      setDescription({ value: groupData.description, error: false, errorMsg: '' });
    }
  }, [groupData]);

  const markDirty = () => { isDirty.current = true; };

  const firstStep = {
    label: 'Criação',
    validation: () => !name.error && !description.error,
    content: (
      <GroupInfo
        nameState={[name, setName]}
        descriptionState={[description, setDescription]}
        markDirty={markDirty}
      />
    ),
  };

  const secondStep = {
    label: 'Usuários',
    validation: () => true,
    content: (
      <UsersShared
        users={users}
        sharedState={[tempShared, setTempShared]}
        markDirty={markDirty}
      />
    ),
  };

  const handleSubmit = () => {
    if (!isDirty.current) {
      hide();
      return;
    }
    submit({
      name: name.value,
      description: description.value,
    },
    tempShared.map((s) => s.value));
  };

  return (
    <>
      <StepProgress
        steps={usersOnly ? [secondStep] : [firstStep, secondStep]}
        hide={hide}
        complete={handleSubmit}
        markersWidth="medium"
        disableUntilValid
        removeMarkers={usersOnly}
      />
    </>
  );
};

export default GroupManager;
